<template>
<router-link :to="'/evento-home/'+evento.id"  class="row yo-text-n white evento" >
  <provider :evento="evento" :rowheight="evheight" ></provider>
  <div class="row">
    <div class="main col mm yo-hidden-phone" :style="'height:'+evheight+'px'">&#160;</div>
    <crediti :evento="evento" :rowheight="evheight" :info="true"></crediti>
    <titolo :evento="evento" :rowheight="evheight" v-on:change="val => evheight=val"></titolo>
  </div>
</router-link>
</template>

<script>
import provider from './Evento-elenco-provider'
import crediti from './Evento-elenco-crediti'
import titolo from './Evento-elenco-titolo-res'
export default {
  props: {
    evento: Object
  },
  components: {
    provider
    ,crediti
    ,titolo
  },
  /*
  mounted() {
    //console.log(this.$refs.infobox.clientHeight)
    var parent= this
    parent.evheight = parent.$refs.infobox.clientHeight
    this.$teras.event.on('appResize', () => {
      console.log(parent.$refs.infobox)
      parent.evheight = parent.$refs.infobox.clientHeight
      //this.terasChange()
  
    })
  },
  */
  data(){
        return{
          evheight: 0
        }
    },
  watch: {
    'this.$refs.infobox':  'terasChange'
  },
  methods: {
    terasChange(){
      //console.log(this.$refs.infobox.clientHeight)

    }
  },
  computed: {
    aevheight: function () {
      return (typeof this.$refs.infobox == 'undefined') ? '100' : this.$refs.infobox.clientHeight
    }
  }
}
</script>


<style>
.evento-elenco-fad .provider{
   border-bottom:10px solid #379EC2;
   color:#353535;
   padding-bottom:4px !important;
}
.evento-elenco-fad > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #0E1C3C;
}
.evento-elenco-fad .side{
   background: #379EC2;

   padding:0 0 0 20px !important;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .side {
  background: #0E1C3C;
}
.evento-elenco-fad .info div{
   background: #0E1C3C;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .info div{
  background: #379EC2;
}
.evento-elenco-fad .main{
   background: #379EC2;
 
   padding:0 0 0 20px !important;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .main {
  background: #0E1C3C;
}


.evento-elenco-fad.pediatria .provider{
   border-bottom:10px solid #EC008C;
}
.evento-elenco-fad.pediatria > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #FBCCE8;
}
.evento-elenco-fad.pediatria .side{
   background: #EC008C;

}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .side {
  background: #FBCCE8;
  color:#353535;
}
.evento-elenco-fad.pediatria .info div{
   background: #FBCCE8;
   color:#353535;
}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .info div{
  background: #EC008C;
  color:#fff;
}
.evento-elenco-fad.pediatria .main{
   background: #EC008C;

}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .main {
  background: #FBCCE8;
  color:#353535;
}



</style>



// WEBPACK FOOTER //
// src/components/Evento-elenco-res.vue